// src/app/guards/auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { DataService } from '../services/data-service';
import { SnackbarService } from '../services/snack-service/snackbar-service';
import { HttpStatusCode } from '@angular/common/http';

export const authGuard: CanActivateFn = (route, state) => {
  const dataService = inject(DataService);
  const snackService = inject(SnackbarService);
  const router = inject(Router);

  if (dataService.isLoggedIn()) {
    return true;
  } else {
    snackService.show('', 'Please login first!', HttpStatusCode.Forbidden);
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url },
    });
  }
};
